module.exports = {"1":"Dårlig","2":"Under middel","3":"Middel","4":"God","5":"Fremragende","1.5":"Dårlig","2.5":"Under middel","3.5":"Middel","4.5":"Fremragende"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/da-DK/star-ratings.json
// module id = 1281
// module chunks = 0